import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import api from "../../lib/api";
import { WHATSAPP_HREF } from "../../lib/team";

const srcOf = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const ServicesOverview = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(Array.isArray(r.data) ? r.data : [])).catch(() => setServices([]));
  }, []);

  return (
    <section className="px-6 sm:px-12 py-24 sm:py-36" style={{ background: "#F2EFE9" }} data-testid="home-services">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-[11px] uppercase tracking-[0.3em] mb-6" style={{ color: "#FF2800" }}>Cosa facciamo</div>
        <h2 className="text-4xl sm:text-6xl mb-6 max-w-[900px]" style={{ color: "#111", fontWeight: 300, letterSpacing: "-0.02em", lineHeight: 1.05 }}>
          Non solo motori.
        </h2>
        <p className="text-[17px] sm:text-[19px] max-w-[680px] mb-16 sm:mb-20" style={{ color: "#5a5a5a", lineHeight: 1.6 }}>
          Giriamo e montiamo video per ogni tua idea, e raccontiamo al meglio quello che vuoi comunicare. Con te, il nostro team scrive lo storytelling da seguire.
        </p>
        <div className="border-t" style={{ borderColor: "rgba(0,0,0,0.12)" }}>
          {services.map((s, i) => <ServiceRow key={s.id} s={s} i={i} />)}
        </div>
        <div className="mt-14 flex flex-wrap gap-4">
          <Link to="/servizi" className="px-8 py-4 text-[14px] transition-opacity duration-300 hover:opacity-85" style={{ background: "#111", color: "#FFF" }} data-testid="home-services-all">
            Scopri i servizi
          </Link>
          <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="px-8 py-4 text-[14px] transition-opacity duration-300 hover:opacity-85" style={{ background: "#25D366", color: "#FFF", fontWeight: 500 }} data-testid="home-services-wa">
            Chiedi un preventivo
          </a>
        </div>
      </div>
    </section>
  );
};

function ServiceRow({ s, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: i * 0.06 }}
    >
      <Link
        to="/servizi"
        className="group grid grid-cols-[auto_1fr] sm:grid-cols-[60px_1fr_1.2fr_180px] gap-x-6 gap-y-3 items-center py-8 sm:py-10 border-b"
        style={{ borderColor: "rgba(0,0,0,0.12)" }}
        data-testid={`home-service-${i}`}
      >
        <span className="text-[12px]" style={{ color: "#FF2800", letterSpacing: "0.2em" }}>{String(i + 1).padStart(2, "0")}</span>
        <div className="flex items-center gap-3">
          <span className="text-2xl sm:text-3xl transition-transform duration-300 group-hover:translate-x-2" style={{ color: "#111", fontWeight: 400, letterSpacing: "-0.01em" }}>
            {s.kicker || s.title}
          </span>
          <ArrowUpRight size={20} className="opacity-0 group-hover:opacity-100 transition-opacity duration-300" color="#FF2800" />
        </div>
        <p className="col-span-2 sm:col-span-1 text-[15px]" style={{ color: "#5a5a5a", lineHeight: 1.6 }}>{s.body}</p>
        {s.image_url ? (
          <div className="hidden sm:block overflow-hidden" style={{ aspectRatio: "4/3" }}>
            <img src={srcOf(s.image_url)} alt={s.kicker || s.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          </div>
        ) : <span className="hidden sm:block" />}
      </Link>
    </motion.div>
  );
}
